import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import TextEvents from '../TextEvents';
import { Table, Button } from 'antd';
import CommunicationProgramManagementContainer from 'app/containers/CommunicationProgramManagementContainer';
import { useDispatch, useSelector } from 'react-redux';
import { EXPORT_CA_REQUEST, EXPORT_CA_SUCCESS, EXPORT_CA_FAILURE } from 'app/actions/CommunicationProgramActions';

import ApiService from 'app/services/ApiService';

export default function CommunicationProgramManagmentForm(props) {
    const [front] = useState('');
    const [sorter, setSorter] = useState({});
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const isOilService = props.subdirectionId === 3;
    const dispatch = useDispatch();

    const {
        isLoadingCAExport
    } = useSelector(state => state.CommunicationProgram);

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const IsSuperAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Super Administrador')) {
                return true;
            }

        }
        return null;
    }

    const data = {
        frontId: front,
        IdCommunicationProgram: props.rowData.idCommunicationProgram,
        IdSpecialty: props.categoryData.idSpecialty,
        IdCategory: props.categoryData.idCategory,
        Course: props.categoryData.idCourse,
        limit: pagination.pageSize,
        offset: (0 * pagination.pageSize),
        sortColumn: Object.keys(sorter).length > 0 ? sorter.field : '',
        sortDir: Object.keys(sorter).length > 0 ? sorter.order === 'ascend' ? 'ASC' : 'DESC' : '',
        EsSuperAdmin: 0,
    }

    const toExport = () => {
        const params = {
            IdCommunicationProgram: String(props.rowData.idCommunicationProgram),
            IdSpecialty: String(props.categoryData.idSpecialty === null ? '' : props.categoryData.idSpecialty),
            IdCategory: String(props.categoryData.idCategory),
            IdCourse: String(props.categoryData.idCourse),
        }

        var respnse = IsSuperAdmin();
        params.EsSuperAdmin = respnse ? 1 : 0
        dispatch({ type: EXPORT_CA_REQUEST });
        ApiService.exportComplianceAdvance(params)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, 'ProgramadeComunicaciones.xlsx');
                    dispatch({ type: EXPORT_CA_SUCCESS });
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    dispatch({ type: EXPORT_CA_FAILURE });
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }
    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div>
            <Grid container direction='row'>
                <Grid item xs={2} style={props.styles.inputSelect}>
                    Subdirección Origen:
                    <TextEvents
                        text={props.rowData.subdirectionName}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </Grid>
                <Grid item xs={5} style={props.styles.inputSelect}>
                    Programa de comunicación:
                    <TextEvents
                        text={props.rowData.communicationProgramName}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </Grid>
                <Grid item xs={2} style={props.styles.inputSelect}>
                    Especialidad/Sistema:
                    <TextEvents
                        text={props.categoryData.specialtyNameReal}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </Grid>
                <Grid item xs={3} style={props.styles.inputSelect}>
                    Puesto:
                    <TextEvents
                        text={props.categoryData.categoryName}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </Grid>
            </Grid>
            <Grid container direction='row'>
                {isOilService ? (<Grid item xs={3} style={props.styles.inputSelect}>
                    Contrato:
                    <TextEvents
                        text={props.rowData.contractName}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </Grid>) : null}
                {isOilService ? (<Grid item xs={2} style={props.styles.inputSelect}>
                    OT:
                    <TextEvents
                        text={props.rowData.workName}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </Grid>) : null}
                <Grid item xs={isOilService ? 5 : 8} style={props.styles.inputSelect}>
                    Procedimiento/Material de Capacitación:
                    <TextEvents
                        text={props.categoryData.courseName/*original: props.rowData.courseName*/}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </Grid>
                <Grid item xs={isOilService ? 2 : 4} style={props.styles.inputSelect}>
                    Tipo de Capacitación:
                    <TextEvents
                        text={props.rowData.trainingName}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </Grid>
            </Grid>
            <CommunicationProgramManagementContainer pagination={pagination}
                sorter={sorter}
                setSorter={setSorter}
                formData={data}
                setPagination={setPagination}
                idCategory={props.categoryData.idCategory}
                idCommunicationProgram={props.rowData.idCommunicationProgram}
                idContract={props.rowData.idContract}
                idSpecialty={props.categoryData.idSpecialty}
                classes={props.classes}
                idCourse={props.categoryData.idCourse}
            >
                {(params) => {
                    return <div>
                        <Grid container direction='row'>
                            <Grid item xs={3} style={props.styles.inputSelect}>
                                Colaboradores:
                                <TextEvents
                                    text={Object.keys(params.defaultData).length > 0 ? params.defaultData.Total : ''}
                                    color='cotemar'
                                    size='label'
                                    weight='bold'
                                />
                            </Grid>
                            <Grid item xs={3} style={props.styles.inputSelect}>
                                Pendiente(s):
                                <TextEvents
                                    text={Object.keys(params.defaultData).length > 0 ? params.defaultData.Pending : ''}
                                    color='cotemar'
                                    size='label'
                                    weight='bold'
                                />
                            </Grid>
                            <Grid item xs={3} style={props.styles.inputSelect}>
                                Comunicados:
                                <TextEvents
                                    text={Object.keys(params.defaultData).length > 0 ? params.defaultData.Communicated : ''}
                                    color='cotemar'
                                    size='label'
                                    weight='bold'
                                />
                            </Grid>
                            <Grid item xs={3} style={props.styles.inputSelect}>
                                Aprobados:
                                <TextEvents
                                    text={Object.keys(params.defaultData).length > 0 ? params.defaultData.Finished : ''}
                                    color='cotemar'
                                    size='label'
                                    weight='bold'
                                />
                            </Grid>
                        </Grid>
                        <div className={props.classes.container} style={props.styles.baseVerticalMargin}>
                            <Button
                                className={props.classes.button}
                                variant='contained'
                                type='primary'
                                onClick={() => toExport()}
                                loading={isLoadingCAExport}
                            >
                                Exportar
                            </Button>
                        </div>
                        <Table
                            loading={params.isLoading}
                            rowKey={item => String(item.employeeId)}
                            columns={params.cols}
                            dataSource={params.complianceAdvance}
                            onChange={params.handleTableChange}
                            pagination={pagination}
                            // scroll={{ y: 250, x: '100%' }}
                            scroll={{ x: '100%', y: (height - 465) }}
                            size={"small"}
                        />
                    </div>
                }}
            </CommunicationProgramManagementContainer>


        </div>
    )

}